// extracted by mini-css-extract-plugin
module.exports = {"aiPostForm":"AIPostForm_aiPostForm__1-YvU"};